export default __webpack_public_path__ + "static/media/iso.sinfondo.negro.29b0b4fb.png";